
import PropTypes from "prop-types";
import React from "react";
import { DatePicker } from "react-md/lib/Pickers";
import { dateToString } from "components/Shared/Formatters";

const DatePickerField = props =>
  (<DatePicker {...props}
    className={` ${props.containerClassName}`}
    onChange={props.input.onChange}
    name={props.name}
    autoOk
    value={dateToString(props.input.value)}
    dateTimeFormat={dateToString}
    fullWidth={false}
    inline
    displayMode="portrait"
  />);

DatePickerField.propTypes = {
  input: PropTypes.object.isRequired,
  name: PropTypes.string,
  containerClassName: PropTypes.string
};
export default DatePickerField;